


























































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie, getStorage } from "@szgc/plt-core-v2";
import { Loading } from "element-ui";
import UserSelect from "../../../components/UserSelect/index.vue";
import { dateFormat, trim } from "../../../util";
import { ElForm } from "element-ui/types/form";
import LogTable from "../../../components/LogTable/index.vue";
import FileList from "../../../components/FileList/index.vue";
import Ctip from "../../../../pt/components/Ctip/index.vue";
import UploadFile from "../../../../pt/components/UploadFile/index.vue";
import UrgerSelect from "../../../../pt/components/UrgerSelect/index.vue";

@Component({
  name: "WbenTodoProcessMobile",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    UserSelect,
    LogTable,
    FileList,
    Ctip,
    UrgerSelect
  }
})
export default class WbenTodoProcessMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private enableAddMpders: boolean = false;
  private businessId: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private procTaskName: any = "";
  private realName: any = "";
  private processData: any = null;
  private leftFormData: any = null;
  private submitData: any = {};
  private todoBtns: any = [];
  private nowTodoBtn: any = null;
  private showSubmitForm: boolean = false;
  private handlingOpinion: boolean = false;
  private form: any = {
    optKey: "",
    userName: "",
    userId: "",
    fileName: "",
    fileId: "",
    idea: "",
    ccName: "",
    ccUserIds: ""
  };
  private submitFlag: any = {
    ifAttEnable: false,
    ifAttRequire: false,
    ifUserEnable: false,
    ifUserRequire: false,
    ifCopyEnable: false,
    ifCopyRequire: false
  };
  private todoFlag: any = {
    ifAttEnable: false,
    ifAttRequire: false,
    ifUserEnable: false,
    ifUserRequire: false,
    ifCopyEnable: false,
    ifCopyRequire: false,
    ifNodeEnable: false,
    ifNodeRequire: false
  };
  private userBox: any = {
    show: false
  };
  private users: any = [];
  private ccUserBox: any = {
    show: false
  };
  private ccUsers: any = [];
  private todoUserBox: any = {
    show: false
  };
  private toUsers: any = [];
  private todoCcUserBox: any = {
    show: false
  };
  private toCcUsers: any = [];
  private submitOptions: any = [];
  private rulesTop: any = {};
  private rulesTodo: any = {};
  private todoModalShow: boolean = false;
  private todoForm: any = {
    userName: "",
    userId: "",
    fileName: "",
    fileId: "",
    idea: "",
    ccName: "",
    ccUserIds: "",
    nextNodeKey: ""
  };
  private transmitModalShow: boolean = false;
  private transmitForm: any = {
    userName: "",
    userId: "",
    idea: ""
  };
  private rulesTransmit: any = {
    userName: [{ required: true, message: "转发人接收人不能为空" }],
    idea: [{ required: this.handlingOpinion, message: "转发意见不能为空" }]
  };
  private transmitUserBox: any = {
    show: false
  };
  private transmitUsers: any = [];
  private addUserBox: any = {
    show: false
  };
  private addUsers: any = [];
  private uploadType: string = "";
  private fileUpdLoading: any = null;
  private reqToken: string = "";
  private prefix: string = "";
  private pageData: any = null;
  private nodeList: any = [];
  private fileData: any = [];
  private addUserTimeOut: any = null;
  private iframeUrl: string = "";
  private iframeHeight: string = "0px";
  private token: any = "";

  private enableAddAdvisers: boolean = false; //是否显示会签按钮
  private addAdvisersTimeOut: any = null;
  private addAdvisersBox: any = {
    show: false
  };
  private addAdvisers: any = []; //会签成员
  private todoStatus: any = null;
  private urgersShow: boolean = false; // 催办人弹窗

  onTipSelected(tip: string) {
    this.form.idea = tip;
  }

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      this.token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
      // if (localStorage.getItem('offline') && localStorage.getItem('offline') === "true") {
      // }
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.getFlowData();
    }
  }

  @Watch("form.optKey", { immediate: true })
  private onOptKey(newVal: any) {
    if (newVal === "disagree") {
      this.handleRulesTop(true);
    } else {
      this.handleRulesTop();
    }
  }

  async ideaRequire() {
    if (this.handlingOpinion) {
      if (!this.form.idea) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  /*清除todo附件*/
  clearFile() {
    this.todoForm.fileId = "";
    this.todoForm.fileName = "";
  }

  /*待办的流程事项数据查询*/
  async getFlowData(refresh: boolean = false) {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web",
      procTaskId: this.processData.procTaskId
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getTodoDetail(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取待办的流程事项数据失败:" + message);
        return false;
      }
      if (data) {
        this.pageData = data;
        this.nodeList = data.nodeList ? data.nodeList : [];
        this.businessId = this.processData.businessId;
        this.enableAddMpders = data.enableAddMpders;
        this.title = data.businessName;
        this.userName = data.task.realName;
        this.timeText = data.task.createTime ? dateFormat(data.task.createTime) : "--";
        if (refresh) {
          //退出编辑只更新左边表单数据
          this.leftFormData = data;
        } else {
          this.procTaskName = data.task.procTaskName;
          this.realName = data.task.realName;
          this.leftFormData = data;
          this.submitData = data.submit; //相关意见按钮
          this.todoStatus = data.task.status;
          this.enableAddAdvisers = data.enableAddAdvisers;
          this.todoBtns = data.todoList || []; //相关意见虚线下方按钮
          this.handlingOpinion = data.handlingOpinion;
          this.handleSubmit();
          this.handleRulesTop();
        }
        this.reqToken = data.reqToken;
        this.showSubmitForm = data.submit.enable;
        this.fileData = data.atts;
        if (this.leftFormData.packageType === 3) {
          const iframeConfig: any = JSON.parse(this.leftFormData.fields.iframe.value);
          const path = iframeConfig.web;
          const searchParams = new URLSearchParams({
            businessId: this.businessId,
            procTaskId: this.processData.procTaskId,
            clientType: "web",
            page: "todo"
          });
          if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
            this.iframeUrl = `${path}?${searchParams}`;
          } else {
            this.iframeUrl = `${window.origin}${path}?${searchParams}`;
          }
          this.iframeHeight = iframeConfig.padHeight + "px";
        }
      } else {
        this.$message.error("获取待办的流程事项数据失败:" + message);
      }
    } catch (error: any) {
      this.$message.error("获取待办的流程事项数据失败:" + error);
    }
  }

  destroyed() {
    window.removeEventListener("message", this.getMessage);
  }

  /*iframe加载完毕*/
  bindEvent() {
    this.$nextTick(() => {
      window.addEventListener("message", this.getMessage);
    });
  }

  /*iframe子传父*/
  getMessage(event: any) {
    const data = event.data;
    if (data && data.data && data.type && data.type === "szgc-wbench-iframe") {
      if (data.page && data.page === "todo") {
        if (data.btnKey === "submit") {
          //提交
          this.handleSubmitEvt(data.data);
        } else {
          //其它
          this.handleTodoAction(data.data);
        }
      }
    }
  }

  /*iframe父传子*/
  sendMessage(btnKey: any, optKey: boolean) {
    let iframe: any = this.$refs.wbenchIframe;
    iframe.contentWindow.postMessage(
      {
        page: "todo",
        btnKey: btnKey,
        optKey, // 传给iframe同意或不同意的值  同意 agree 不同意 disagree
        type: "szgc-wbench-iframe"
      },
      this.iframeUrl
    );
  }

  /*处理展现相关意见表单展现*/
  handleSubmit() {
    const submitOptions: any = [];
    if (
      this.submitData.options &&
      this.submitData.options.length &&
      this.submitData.options.length > 0
    ) {
      this.submitData.options.map((item: any) => {
        submitOptions.push(item);
      });
    }
    this.submitOptions = submitOptions;
    this.form.optKey = this.submitOptions.length > 0 ? this.submitOptions[0].optKey : "";
  }

  /*处理submit必填项*/
  handleRulesTop(disabledRequired = false) {
    this.submitFlag = {
      ifAttEnable: this.submitData.ifAttEnable,
      ifAttRequire: this.submitData.ifAttRequire,
      ifUserEnable: this.submitData.ifUserEnable,
      ifUserRequire: this.submitData.ifUserRequire,
      ifCopyEnable: this.submitData.ifCopyEnable,
      ifCopyRequire: this.submitData.ifCopyRequire
    };
    if (disabledRequired) {
      this.submitFlag = {
        ifAttEnable: this.submitData.ifAttEnable,
        ifAttRequire: false,
        ifUserEnable: this.submitData.ifUserEnable,
        ifUserRequire: false,
        ifCopyEnable: this.submitData.ifCopyEnable,
        ifCopyRequire: false
      };
    }
    this.rulesTop = {
      userName: [{ required: this.submitFlag.ifUserRequire, message: "操办人不能为空" }],
      ccName: [{ required: this.submitFlag.ifCopyRequire, message: "抄送人不能为空" }],
      fileName: [
        {
          required: this.submitFlag.ifAttEnable && this.submitFlag.ifAttRequire,
          message: "附件不能为空"
        }
      ],
      idea: [{ required: this.handlingOpinion, message: "处理意见不能为空" }]
    };
    this.rulesTransmit = {
      userName: [{ required: true, message: "转发人接收人不能为空" }],
      idea: [{ required: this.handlingOpinion, message: "转发意见不能为空" }]
    };
  }

  /*submit操办人选择*/
  userChecked(data: any) {
    if (data.source.length === 0) {
      this.users = [];
      this.form.userName = "";
      this.form.userId = "";
      return;
    }
    this.form.userName = data.text;
    this.form.userId = data.valueText;
    this.users = this.form.userId.split(",");
  }

  /*submit抄送人选择*/
  ccUserChecked(data: any) {
    if (data.source.length === 0) {
      this.ccUsers = [];
      this.form.ccName = "";
      this.form.ccUserIds = "";
      return;
    }
    this.form.ccName = data.text;
    this.form.ccUserIds = data.valueText;
    this.ccUsers = this.form.ccUserIds.split(",");
  }

  /*todo操办人弹窗*/
  showTodoUserBox() {
    this.todoUserBox.show = true;
  }

  /*todo操办人选择*/
  todoUserChecked(data: any) {
    if (data.source.length === 0) {
      this.toUsers = [];
      this.todoForm.userName = "";
      this.todoForm.userId = "";
      return;
    }
    this.todoForm.userName = data.text;
    this.todoForm.userId = data.valueText;
    this.toUsers = this.todoForm.userId.split(",");
  }

  /*todo抄送人弹窗*/
  showTodoCcUserBox() {
    this.todoCcUserBox.show = true;
  }

  /*todo抄送人选择*/
  todoCcUserChecked(data: any) {
    if (data.source.length === 0) {
      this.toCcUsers = [];
      this.todoForm.ccName = "";
      this.todoForm.ccUserIds = "";
      return;
    }
    this.todoForm.ccName = data.text;
    this.todoForm.ccUserIds = data.valueText;
    this.toCcUsers = this.todoForm.ccUserIds.split(",");
  }

  /*转发接收人弹窗*/
  showTransmitUserBox() {
    this.transmitUserBox.show = true;
  }

  /*转发接收人选择*/
  transmitUserChecked(data: any) {
    if (data.source.length === 0) {
      this.transmitUsers = [];
      this.transmitForm.userName = "";
      this.transmitForm.userId = "";
      return;
    }
    this.transmitForm.userName = data.text;
    this.transmitForm.userId = data.valueText;
    this.transmitUsers = this.transmitForm.userId.split(",");
  }

  /*转发弹窗*/
  transmitEvt() {
    this.transmitModalShow = true;
  }
  submitForm(formName: string) {
    let res = true;
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (!valid) {
        res = false;
      }
    });
    return res;
  }
  /*转发提交*/
  async transmit() {
    if (!this.submitForm("wbenTransmitForm")) return;
    let flag;
    await (this.$refs.wbenTransmitForm as ElForm).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      let ccs: any = [];
      if (this.transmitForm.userName !== "") {
        //转发人
        let ccUserIds = this.transmitForm.userId.split(","),
          ccUserNames = this.transmitForm.userName.split(",");
        for (let i = 0; i < ccUserIds.length; i++) {
          ccs.push({
            realName: ccUserNames[i],
            userId: ccUserIds[i]
          });
        }
      }
      try {
        const { success, message } = await request({
          url: this.prefix + Api.transmitProcess(),
          method: "post",
          data: {
            businessName: this.pageData.businessName,
            businessId: this.pageData.businessId,
            ccs: ccs.length > 0 ? ccs : null,
            idea: trim(this.transmitForm.idea),
            proTaskId: this.pageData.task.procTaskId,
            procTaskName: this.pageData.task.procTaskName,
            utKey: this.pageData.task.utKey
          }
        });
        if (!success) {
          this.$message.error(`转发失败:${message}`);
          return false;
        }
        this.transmitModalShow = false;
        this.$message.success(`转发成功`);
        this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
      } catch (error: any) {
        this.$message.error(`转发失败:${error}`);
      }
    }
  }

  /*添加会签成员弹窗*/
  async showAddUserBox() {
    const res = await this.ideaRequire();
    if (!res) return;
    this.addUsers = [];
    this.addUserBox.show = true;
  }

  /*添加会签成员弹窗*/
  showAddAdvisersBox() {
    this.addAdvisers = [];
    this.addAdvisersBox.show = true;
  }

  /*添加会签人选择*/
  async addUserChecked(personData: any) {
    if (personData.source.length === 0) {
      this.addUsers = [];
      return;
    }
    const valueText = personData.valueText;
    const addMpders: any[] = [];
    personData.source.map((item: any) => {
      addMpders.push({
        realName: item.realName,
        userId: item.userId
      });
    });
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.addMpders(),
        method: "post",
        data: {
          addMpders,
          businessId: this.processData.businessId,
          procTaskId: this.processData.procTaskId
        }
      });
      if (!success) {
        this.$message.error(`添加会签成员失败:${message}`);
        return false;
      }
      if (data) {
        this.$message.error(data);
        return false;
      }
      this.$message.success(`添加会签成员成功`);
      this.addUsers = valueText.split(",");
      this.businessId = "";
      this.addUserTimeOut = setTimeout(() => {
        this.addUserBox.show = false;
        this.businessId = this.processData.businessId;
        clearTimeout(this.addUserTimeOut);
        this.addUserTimeOut = null;
      }, 100);
    } catch (error: any) {
      console.error(error);

      this.$message.error(`添加会签成员失败:${error}`);
    }
  }

  /*添加会签人选择*/
  async addAdvisersChecked(personData: any) {
    if (personData.source.length === 0) {
      this.addAdvisers = [];
      return;
    }
    const valueText = personData.valueText;
    const addAdvisers: any[] = [];
    personData.source.map((item: any) => {
      addAdvisers.push({
        realName: item.realName,
        userId: item.userId
      });
    });
    try {
      const { success, message, data } = await request({
        url: this.prefix + Api.addAdvisers(),
        method: "post",
        data: {
          addAdvisers,
          businessId: this.processData.businessId,
          procTaskId: this.processData.procTaskId
        }
      });
      if (!success) {
        this.$message.error(`添加会签成员失败:${message}`);
        return false;
      }
      if (data) {
        this.$message.error(data);
        return false;
      }
      this.$message.success(`添加会签成员成功`);
      this.addUsers = valueText.split(",");
      this.businessId = "";
      this.addAdvisersTimeOut = setTimeout(() => {
        this.addAdvisersBox.show = false;
        this.businessId = this.processData.businessId;
        clearTimeout(this.addAdvisersTimeOut);
        this.addAdvisersTimeOut = null;
      }, 100);
    } catch (error: any) {
      console.error(error);
      this.$message.error(`添加会签成员失败:${error}`);
    }
  }

  /*submit提交*/
  async submitEvt() {
    let flag;
    await (this.$refs.wbenTodoProForm as ElForm).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      if (this.leftFormData.packageType !== 3) {
        //非iframe
        // 选择不同意时不做校验
        const allData = await (this.$refs.wbenTodoForm as any).getBackFormData(
          this.form.optKey === "agree"
        );
        let formBoxData = {};
        if (!allData.valid) {
          this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
          return false;
        }
        formBoxData = allData.data;
        this.handleSubmitEvt(formBoxData);
      } else {
        this.sendMessage(this.submitData.btnKey, this.form.optKey);
      }
    }
  }

  /*submit接口请求*/
  async handleSubmitEvt(formBoxData: any) {
    let ccs: any = [],
      nextCus: any = [],
      optionName: any = "";
    if (this.form.ccUserIds !== "") {
      //抄送人
      let ccUserIds = this.form.ccUserIds.split(","),
        ccUserNames = this.form.ccName.split(",");
      for (let i = 0; i < ccUserIds.length; i++) {
        ccs.push({
          realName: ccUserNames[i],
          userId: ccUserIds[i]
        });
      }
    }
    if (this.form.userId !== "") {
      //操办人
      let userIds = this.form.userId.split(","),
        userNames = this.form.userName.split(",");
      for (let j = 0; j < userIds.length; j++) {
        nextCus.push({
          realName: userNames[j],
          userId: userIds[j]
        });
      }
    }
    for (let k = 0; k < this.submitOptions.length; k++) {
      if (this.submitOptions[k].optKey === this.form.optKey) {
        optionName = this.submitOptions[k].optName;
        break;
      }
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.sendTodoHasForm(),
        method: "post",
        data: {
          attIds: this.form.fileId === "" ? null : this.form.fileId,
          businessId: this.pageData.businessId,
          ccs: ccs.length > 0 ? ccs : null,
          fields: formBoxData,
          idea: trim(this.form.idea),
          nextCus: nextCus,
          optionKey: this.form.optKey,
          optionName: optionName,
          procTaskId: this.pageData.task.procTaskId,
          reqToken: this.reqToken
        }
      });
      if (!success) {
        this.$message.error(`${this.submitData.btnName}失败:${message}`);
        return false;
      }
      this.$message.success(`${this.submitData.btnName}成功`);
      this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
    } catch (error: any) {
      this.$message.error(`${this.submitData.btnName}失败:${error}`);
    }
  }

  /* 催办先选人 */
  async urgeEvt() {
    const res = await this.ideaRequire();
    if (!res) return;
    this.urgersShow = true;
  }

  /* 催办 */
  async handleUrgeEvt(data: any) {
    const res = await this.ideaRequire();
    if (!res) return;
    const urgerIds: any = [...data.childMatterUrgers, ...data.curMatterUrgers];
    try {
      const { success, message } = await request({
        url: this.prefix + Api.urgeProcess(this.processData.businessId),
        method: "put",
        data: {
          urgerIds
        }
      });
      if (!success) {
        this.$message.error(`催办失败:${message}`);
        return false;
      }
      this.$message.success(`催办成功`);
      this.urgersShow = false;
    } catch (error) {
      this.$message.error(`催办失败:${error}`);
    }
  }

  /*todoBtn点击虚线下方按钮*/
  async todoBtnEvt(item: any) {
    if (item.btnKey !== "return") {
      const res = await this.ideaRequire();
      if (!res) return;
    }
    this.nowTodoBtn = item;
    this.todoFlag = {
      ifAttEnable: item.ifAttEnable,
      ifAttRequire: item.ifAttRequire,
      ifUserEnable: item.ifUserEnable,
      ifUserRequire: item.ifUserRequire,
      ifCopyEnable: item.ifCopyEnable,
      ifCopyRequire: item.ifCopyRequire,
      ifNodeEnable: item.ifNodeEnable,
      ifNodeRequire: item.ifNodeRequire
    };
    let nextNodeKey = "";
    if (this.nowTodoBtn.btnKey === "goto") {
      if (this.nodeList.length > 0 && !this.nowTodoBtn.nextNodeKey) {
        nextNodeKey = this.nodeList[0].nodeKey;
      } else {
        nextNodeKey = this.nowTodoBtn.nextNodeKey;
      }
    }
    this.todoForm = {
      userName: "",
      userId: "",
      fileName: "",
      fileId: "",
      idea: "",
      ccName: "",
      ccUserIds: "",
      nextNodeKey: nextNodeKey
    };
    if (this.nowTodoBtn.needSecondSubmit) {
      //有二次提交
      this.rulesTodo = {
        userName: [{ required: this.todoFlag.ifUserRequire, message: "操办人不能为空" }],
        ccName: [{ required: this.todoFlag.ifCopyRequire, message: "抄送人不能为空" }],
        fileName: [{ required: this.todoFlag.ifAttRequire, message: "附件不能为空" }]
      };
      this.todoModalShow = true;
    } else {
      this.rulesTodo = null;
      this.todoSureEvt();
    }
  }

  /*todoBtn确定*/
  async todoSureEvt() {
    let flag = true;
    if (this.rulesTodo) {
      await (this.$refs.wbenTodoBtnForm as any).validate((valid: any) => {
        flag = valid;
      });
    }
    if (flag) {
      let formBoxData = {};
      if (this.leftFormData.packageType !== 3) {
        //非iframe
        if (this.nowTodoBtn.btnKey === "return") {
          //退回return
          const allData = await (this.$refs.wbenTodoForm as any).getBackFormData(false);
          formBoxData = allData.data;
        } else {
          // 选择不同意时不做校验
          const allData = await (this.$refs.wbenTodoForm as any).getBackFormData(
            this.form.optKey === "agree"
          );
          if (!allData.valid) {
            this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
            return false;
          }
          formBoxData = allData.data;
        }
        this.handleTodoAction(formBoxData);
      } else {
        this.sendMessage(this.nowTodoBtn.btnKey, this.form.optKey);
      }
    }
  }

  /*todoBtn接口请求*/
  async handleTodoAction(formBoxData: any) {
    let ccs: any = [],
      nextCus: any = [];
    if (this.todoForm.ccUserIds !== "") {
      //抄送人
      let ccUserIds = this.todoForm.ccUserIds.split(","),
        ccUserNames = this.todoForm.ccName.split(",");
      for (let i = 0; i < ccUserIds.length; i++) {
        ccs.push({
          realName: ccUserNames[i],
          userId: ccUserIds[i]
        });
      }
    }
    if (this.todoForm.userId !== "") {
      //操办人
      let userIds = this.todoForm.userId.split(","),
        userNames = this.todoForm.userName.split(",");
      for (let j = 0; j < userIds.length; j++) {
        nextCus.push({
          realName: userNames[j],
          userId: userIds[j]
        });
      }
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.todoTaskForm(),
        method: "post",
        data: {
          attIds: this.todoForm.fileId === "" ? null : this.todoForm.fileId,
          btnKey: this.nowTodoBtn.btnKey,
          businessId: this.processData.businessId,
          ccs: ccs,
          fields: formBoxData,
          idea: trim(this.form.idea),
          nextCus: nextCus,
          procTaskId: this.processData.procTaskId,
          reqToken: this.reqToken,
          nextNodeKey: this.todoForm.nextNodeKey
        }
      });
      if (!success) {
        this.$message.error(`${this.nowTodoBtn.btnName}失败:${message}`);
        return false;
      }
      this.$message.success(`${this.nowTodoBtn.btnName}成功`);
      this.todoModalShow = false;
      this.$emit("childEvt", { type: "close" });
    } catch (error: any) {
      this.$message.error(`${this.nowTodoBtn.btnName}失败:${error}`);
    }
  }

  /*多文件上传点击*/
  showMulUpload(type: any) {
    this.uploadType = type;
    (document.getElementById("submitUploadFile") as any).value = "";
    (document.getElementById("submitUploadFile") as HTMLDivElement).click();
  }

  /*多文件上传*/
  multiUpload(event: any) {
    let files = event.target.files;
    let formData = new FormData();
    if (files.length === 0) {
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    this.fileUpdLoading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "附件上传中..."
    });
    request({
      url: this.prefix + Api.mulUploadFiles,
      method: "post",
      data: formData
    })
      .then((res: any) => {
        if (res.success) {
          let tempIds: any = [],
            tempNames: any = [];
          if (res.data && res.data.length && res.data.length > 0) {
            res.data.map((item: any) => {
              tempIds.push(item.fileId);
              tempNames.push(item.name);
            });
          }
          if (this.uploadType === "submit") {
            this.form.fileName = tempNames.join(",");
            this.form.fileId = tempIds;
          } else {
            this.todoForm.fileName = tempNames.join(",");
            this.todoForm.fileId = tempIds;
          }
          this.$message.success("附件上传成功");
        } else {
          if (this.uploadType === "submit") {
            this.form.fileName = "";
            this.form.fileId = "";
          } else {
            this.todoForm.fileName = "";
            this.todoForm.fileId = "";
          }
          this.$message.error("附件上传失败");
        }
        this.fileUpdLoading.close();
      })
      .catch((error: any) => {
        if (this.uploadType === "submit") {
          this.form.fileName = "";
          this.form.fileId = "";
        } else {
          this.todoForm.fileName = "";
          this.todoForm.fileId = "";
        }
        this.fileUpdLoading.close();
        this.$message.error("附件上传失败: " + error);
      });
  }

  /*左边表单点击操作按钮之后关闭弹窗*/
  childEvt(data: any) {
    if (data.type === "close") {
      this.$emit("childEvt", { type: "close" });
    } else if (data.type === "refresh") {
      this.getFlowData(true);
    }
  }
}
